import React from 'react';
import { motion } from 'framer-motion';
import { Utensils, Sparkles, Moon } from 'lucide-react';
export function ZeroCapaMethod() {
  const steps = [{
    icon: <Utensils className="w-8 h-8" data-id="element-204" />,
    title: 'La Cocina',
    desc: 'Eliminamos los ingredientes inflamatorios ocultos en tu alimentación diaria.'
  }, {
    icon: <Sparkles className="w-8 h-8" data-id="element-205" />,
    title: 'El Baño',
    desc: 'Sustituimos los productos de belleza cargados de disruptores hormonales.'
  }, {
    icon: <Moon className="w-8 h-8" data-id="element-206" />,
    title: 'El Dormitorio',
    desc: 'Neutralizamos las toxinas invisibles que afectan tu descanso y recuperación.'
  }];
  return <section className="py-24 bg-sage-dark text-cream relative overflow-hidden" data-id="element-207">
      {/* Decorative background elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none" data-id="element-208">
        <div className="absolute -top-24 -left-24 w-96 h-96 bg-sage rounded-full opacity-20 blur-3xl" data-id="element-209"></div>
        <div className="absolute -bottom-24 -right-24 w-96 h-96 bg-sage rounded-full opacity-20 blur-3xl" data-id="element-210"></div>
      </div>

      <div className="max-w-6xl mx-auto px-6 lg:px-8 relative z-10" data-id="element-211">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-212">
          <span className="text-sage-light font-bold tracking-wider uppercase text-sm mb-4 block" data-id="element-213">
            El Mecanismo Único
          </span>
          <h2 className="text-3xl md:text-5xl font-serif mb-6 text-white" data-id="element-214">
            El Método Zero-Capa
          </h2>
          <p className="text-lg md:text-xl text-cream/80 max-w-3xl mx-auto leading-relaxed" data-id="element-215">
            Se enfoca en eliminar capa por capa los químicos ocultos en tu vida
            diaria. Este enfoque integral restaura el equilibrio hormonal y
            permite que tu metabolismo vuelva a funcionar.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-216">
          {steps.map((step, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.6,
          delay: index * 0.2
        }} className="bg-white/10 backdrop-blur-md border border-white/20 rounded-3xl p-8 text-center hover:bg-white/15 transition-colors" data-id="element-217">
              <div className="w-16 h-16 mx-auto bg-sage-light text-sage-dark rounded-full flex items-center justify-center mb-6 shadow-lg" data-id="element-218">
                {step.icon}
              </div>
              <h3 className="text-2xl font-serif mb-4 text-white" data-id="element-219">
                {index + 1}. {step.title}
              </h3>
              <p className="text-cream/80 leading-relaxed" data-id="element-220">{step.desc}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}